import(/* webpackMode: "eager", webpackExports: ["AiPhotoStudioView"] */ "/app/apps/frontend/components/ai-photo-studio/view.tsx");
